import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminUserOrganizationsPermissionsReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminUserOrganizationsPermissions.request.type]: actionsHandlers.handleGetOneRequest,
  [actions.getAdminUserOrganizationsPermissions.success.type]: actionsHandlers.handleGetOneSuccess,
  [actions.getAdminUserOrganizationsPermissions.failure.type]: actionsHandlers.handleGetOneFailure,
  [actions.getAdminUserOrganizationsPermissions.reset.type]: actionsHandlers.handleGetOneReset,
});

export default adminUserOrganizationsPermissionsReducer;
